import { useState } from 'react';
import useForecastTrackingEvents from '../../useForecastTrackingEvents';

export const FORECAST_CHART_TYPES = {
  PROBABILITY: {
    key: 'PROBABILITY',
    name: 'Probability',
    getConfig: ({ forecast }) => ({
      getValue: point => Number(point?.totalProbability * 100),
      yAxis: {
        max: 100,
        labelFormatter: label => `${label.value}%`,
        getTickInterval: () => {
          if (forecast?.unfinished?.probability >= 0.5) return null;
          return 25;
        }
      }
    })
  },
  FREQUENCY: {
    key: 'FREQUENCY',
    name: 'Distribution',
    getConfig: () => ({
      getValue: point => point?.frequency
    })
  }
};

const useChartType = () => {
  const [chartType, setChartType] = useState(FORECAST_CHART_TYPES.PROBABILITY);
  const trackingEvents = useForecastTrackingEvents();

  const options = Object.values(FORECAST_CHART_TYPES).map(chartType => ({
    value: chartType.key,
    name: chartType.name
  }));

  const onChange = option => {
    const newChartType = FORECAST_CHART_TYPES[option.value];
    setChartType(newChartType);
    trackingEvents.onChangeColumnChartType(newChartType.key);
  };

  return {
    ...chartType,
    onChange,
    options
  };
};

export default useChartType;
